import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useLocation } from "react-router-dom/dist";

import logo from "../assets/images/logo.webp";
import RNG from "../assets/images/providers/rng-certified.png";
import Gambling from "../assets/images/providers/gambling-commission.png";
import ResponsibleG from "../assets/images/providers/responsible-gaming.png";
import Gamble18 from "../assets/images/providers/gamble-resp-18.png";
import Email from "../assets/images/icons/email.png";
import MenuIcon from "../assets/images/icons/menu.png";
import CasinoIcon from "../assets/images/icons/Exchange.png";
import CasinoIconNew from "../assets/images/icons/cards.png";
import SlotsIcon from "../assets/images/icons/dice.png";
import SportsIcon1 from "../assets/images/icons/throw.png";
import { handleRightSideBar } from "../redux/app/actions";
import { useDispatch } from "react-redux";
import AppDownload from "../assets/images/icons/download.png";
import ezugi_icon from "../assets/images/icons/ezugu_icon.gif";
import GamesSearchModal from "../views/components/GamesSearchModal";
import TawkChat from "../views/components/TawkChat";
import SupportIcon1 from "../assets/images/icons/customer-service.png";

const Footer = () => {
  const { user } = useSelector((state) => state.auth);
  const tawkMessengerRef = useRef();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const location = useLocation();
  const { showRightSideBar } = useSelector((state) => state.app);
  const [activePage, setActivePage] = useState("");
  const isApk = localStorage.getItem("isApk") === "true";

  const footerPages = [
    "home",
    "sportsbook",
    "casino/evolution",
    "casino/ezugi",
    "gatewaylist",
  ];

  useEffect(() => {
    const matchedValue = footerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const handleSupportClick = () => {
    tawkMessengerRef.current?.toggle();
  };

  return (
    <footer className="footer">
      <Container>
        <div className="email">
          <h6>Email us </h6>
          <a href="mailto:support@litoralfacil.com">
            <img src={Email} alt="email" />
            <span>support@litoralfacil.com</span>
          </a>
        </div>

        <div className="footer-section">
          <div className="footer-left-part">
            <div className="footer-menu-web">
              <ul>
                <li>
                  <a href="/contactus">Contact US</a>
                </li>
                <li>
                  <a href="/privacypolicy">Privacy</a>
                </li>
                <li>
                  <a href="/responsiblegames">Responsible Gaming</a>
                </li>
                <li>
                  <a href="/selfexclusion">Self Exclusion</a>
                </li>
                <li>
                  <a href="/payout">Payout</a>
                </li>

                <li>
                  <a href="/disputeresolution">Dispute Resolution</a>
                </li>

                <li>
                  <a href="/registration">Registration</a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-content">
          <div className="certifiedSec">
            <div className="providers_img">
              <a href="javascript:void(0)">
                <img src={RNG} loading="lazy" alt="RNG Certified" />
              </a>
              <a href="javascript:void(0)">
                <img src={Gambling} loading="lazy" alt="Gambling Commission" />
              </a>
              <a href="javascript:void(0)">
                <img
                  src={ResponsibleG}
                  loading="lazy"
                  alt="Responsible Gaming"
                />
              </a>
              <a href="javascript:void(0)">
                <img src={Gamble18} loading="lazy" alt="Gamble Responsible" />
              </a>
            </div>
          </div>
          <p>
            In order to register for this website, the user is required to
            accept the <a href="/terms">General Terms and Conditions.</a>In the
            event the General Terms and Conditions are updated, existing users
            may choose to discontinue using the products and services before the
            said update shall become effective, which is a minimum of two weeks
            after it has been announced.
          </p>
        </div>

        <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 w-100 d-block d-md-none">
          <ul className="d-flex m-0 p-0 list-unstyled">
            <li>
              <a className="active" href="/live-casino">
                <img src={CasinoIconNew} />
                <span>Casino</span>
              </a>
            </li>
            <li>
              <a className="active" href="/atlas-lobby">
                <img src={CasinoIcon} />
                <span>Football</span>
              </a>
            </li>
            <li>
              <a className="active" href="/slots-games">
                <img src={SlotsIcon} />
                <span>Caça-Niquel</span>
              </a>
            </li>
            <li>
              <a href="/atlas-lobby">
                <img src={SportsIcon1} />
                <span>Apostas Esportiva</span>
              </a>
            </li>

            <li>
              <a href="/contactus" className="SupportSection">
                <img src={SupportIcon1} />
                <span>Support</span>
              </a>
            </li>
            <li>
              <a
                className=""
                href="#"
                onClick={() => {
                  dispatch(handleRightSideBar(!showRightSideBar));
                }}
              >
                <img src={MenuIcon} />
                <span>Menu</span>
              </a>
            </li>
            {!isApk ? (
              // <li>
              //   <a href="#" className="headicons support ">
              //     {/* <img src={AppDownload} /> */}

              //     <GamesSearchModal />
              //     <span>Search</span>
              //   </a>
              // </li>
              <></>
            ) : (
              <li>
                <a href="/casino/ezugi">
                  <img src={ezugi_icon} />
                  <span>Ezugi</span>
                </a>
              </li>
            )}
          </ul>
        </div>
      </Container>

      <div className="copy-right">
        <p>
          Copyright © 2025 <span>Litoralfacil</span> | All rights reserved.
        </p>
      </div>

      <TawkChat ref={tawkMessengerRef} />
    </footer>
  );
};

export default Footer;
